/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentConversationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentConversationsQuery = { agentConversations: { __typename: 'AgentConversationsResult', conversations: Array<{ __typename: 'AgentConversationSummary', id: string, title: string, createdAt: any, updatedAt: any, messageCount: number, running: boolean }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type DeleteAgentConversationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteAgentConversationMutation = { deleteAgentConversation: { __typename: 'AgentDeleteConversationResult', deleted: boolean } };

export type RequestAgentAttachmentUploadUrlMutationVariables = Types.Exact<{
  input: Types.AgentAttachmentUploadUrlInput;
}>;


export type RequestAgentAttachmentUploadUrlMutation = { requestAgentAttachmentUploadUrl: { __typename: 'AgentAttachmentUploadUrlResult', uploadUrl: string, uploadKey: string } };

export type RenameAgentConversationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  title: Types.Scalars['String']['input'];
}>;


export type RenameAgentConversationMutation = { renameAgentConversation: { __typename: 'AgentRenameConversationResult', conversation: { __typename: 'AgentRenamedConversation', id: string, title: string } } };


export const AgentConversationsDocument = gql`
    query AgentConversations {
  agentConversations {
    __typename
    ... on AgentConversationsResult {
      conversations {
        id
        title
        createdAt
        updatedAt
        messageCount
        running
      }
    }
  }
}
    `;

/**
 * __useAgentConversationsQuery__
 *
 * To run a query within a React component, call `useAgentConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentConversationsQuery(baseOptions?: Apollo.QueryHookOptions<AgentConversationsQuery, AgentConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentConversationsQuery, AgentConversationsQueryVariables>(AgentConversationsDocument, options);
      }
export function useAgentConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentConversationsQuery, AgentConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentConversationsQuery, AgentConversationsQueryVariables>(AgentConversationsDocument, options);
        }
export function useAgentConversationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentConversationsQuery, AgentConversationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentConversationsQuery, AgentConversationsQueryVariables>(AgentConversationsDocument, options);
        }
export type AgentConversationsQueryHookResult = ReturnType<typeof useAgentConversationsQuery>;
export type AgentConversationsLazyQueryHookResult = ReturnType<typeof useAgentConversationsLazyQuery>;
export type AgentConversationsSuspenseQueryHookResult = ReturnType<typeof useAgentConversationsSuspenseQuery>;
export type AgentConversationsQueryResult = Apollo.QueryResult<AgentConversationsQuery, AgentConversationsQueryVariables>;
export const DeleteAgentConversationDocument = gql`
    mutation DeleteAgentConversation($id: ID!) {
  deleteAgentConversation(id: $id) {
    deleted
  }
}
    `;
export type DeleteAgentConversationMutationFn = Apollo.MutationFunction<DeleteAgentConversationMutation, DeleteAgentConversationMutationVariables>;

/**
 * __useDeleteAgentConversationMutation__
 *
 * To run a mutation, you first call `useDeleteAgentConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentConversationMutation, { data, loading, error }] = useDeleteAgentConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgentConversationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgentConversationMutation, DeleteAgentConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgentConversationMutation, DeleteAgentConversationMutationVariables>(DeleteAgentConversationDocument, options);
      }
export type DeleteAgentConversationMutationHookResult = ReturnType<typeof useDeleteAgentConversationMutation>;
export type DeleteAgentConversationMutationResult = Apollo.MutationResult<DeleteAgentConversationMutation>;
export type DeleteAgentConversationMutationOptions = Apollo.BaseMutationOptions<DeleteAgentConversationMutation, DeleteAgentConversationMutationVariables>;
export const RequestAgentAttachmentUploadUrlDocument = gql`
    mutation RequestAgentAttachmentUploadUrl($input: AgentAttachmentUploadUrlInput!) {
  requestAgentAttachmentUploadUrl(input: $input) {
    uploadUrl
    uploadKey
  }
}
    `;
export type RequestAgentAttachmentUploadUrlMutationFn = Apollo.MutationFunction<RequestAgentAttachmentUploadUrlMutation, RequestAgentAttachmentUploadUrlMutationVariables>;

/**
 * __useRequestAgentAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useRequestAgentAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAgentAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAgentAttachmentUploadUrlMutation, { data, loading, error }] = useRequestAgentAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestAgentAttachmentUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<RequestAgentAttachmentUploadUrlMutation, RequestAgentAttachmentUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAgentAttachmentUploadUrlMutation, RequestAgentAttachmentUploadUrlMutationVariables>(RequestAgentAttachmentUploadUrlDocument, options);
      }
export type RequestAgentAttachmentUploadUrlMutationHookResult = ReturnType<typeof useRequestAgentAttachmentUploadUrlMutation>;
export type RequestAgentAttachmentUploadUrlMutationResult = Apollo.MutationResult<RequestAgentAttachmentUploadUrlMutation>;
export type RequestAgentAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<RequestAgentAttachmentUploadUrlMutation, RequestAgentAttachmentUploadUrlMutationVariables>;
export const RenameAgentConversationDocument = gql`
    mutation RenameAgentConversation($id: ID!, $title: String!) {
  renameAgentConversation(id: $id, title: $title) {
    conversation {
      id
      title
    }
  }
}
    `;
export type RenameAgentConversationMutationFn = Apollo.MutationFunction<RenameAgentConversationMutation, RenameAgentConversationMutationVariables>;

/**
 * __useRenameAgentConversationMutation__
 *
 * To run a mutation, you first call `useRenameAgentConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameAgentConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameAgentConversationMutation, { data, loading, error }] = useRenameAgentConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameAgentConversationMutation(baseOptions?: Apollo.MutationHookOptions<RenameAgentConversationMutation, RenameAgentConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameAgentConversationMutation, RenameAgentConversationMutationVariables>(RenameAgentConversationDocument, options);
      }
export type RenameAgentConversationMutationHookResult = ReturnType<typeof useRenameAgentConversationMutation>;
export type RenameAgentConversationMutationResult = Apollo.MutationResult<RenameAgentConversationMutation>;
export type RenameAgentConversationMutationOptions = Apollo.BaseMutationOptions<RenameAgentConversationMutation, RenameAgentConversationMutationVariables>;